import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import {
  Dashboard,
  Event,
  EventCreate,
  EventUpdate,
  Hotel,
  HotelCreate,
  HotelUpdate,
  Delegate,
  DelegateCreate,
  DelegateUpdate,
} from "./lazy";
import Layout from "./Layout";
// import Login from "../pages/login/Login";

// import ProtectedRoute from "./ProtectedRoute";

// 🚨 token.js import is no longer needed here, but keeping for reference if logic moves
// import { token } from "../utils/token";

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* <Route path="/login" element={<Login />} /> */}
        <Route
          path="/"
          element={
            // <ProtectedRoute>
            <Layout />
            // </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="dashboard" element={<Dashboard />} />

          <Route path="delegate" element={<Delegate />} />
          <Route path="delegate/delegate/create" element={<DelegateCreate />} />
          <Route
            path="delegate/update/:delegateId"
            element={<DelegateUpdate />}
          />

          <Route path="event" element={<Event />} />
          <Route path="event/create" element={<EventCreate />} />
          <Route path="event/update/:id" element={<EventUpdate />} />

          <Route path="hotel" element={<Hotel />} />
          <Route path="hotel/create" element={<HotelCreate />} />
          <Route path="hotel/update/:id" element={<HotelUpdate />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
